<div class="display-flex flex-column">
  <div mat-dialog-title class="display-flex modal-header">
    <div class="subtitle">Add new space</div>
  </div>

  <mat-dialog-content>
    <div class="templates-list-table-container no-shadow">
      <table mat-table [dataSource]="dataSource$ | async" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let spaceTemplate">{{ spaceTemplate.name }}</td>
        </ng-container>

        <ng-container matColumnDef="isTurboMode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Turbo</th>
          <td mat-cell *matCellDef="let spaceTemplate">
            <app-icon
              *ngIf="spaceTemplate.isTurboMode"
              [svg]="EIcon.TURBO"
              [iconHeight]="24"
              [iconWidth]="24"
            ></app-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="steps">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Steps</th>
          <td mat-cell *matCellDef="let spaceTemplate">{{ spaceTemplate.steps }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let spaceTemplate" class="display-flex justify-content-end grid-gap-8">
            <button mat-stroked-button color="primary" (click)="selectSpaceTemplate(spaceTemplate)">
              Select as template
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr
          *matNoDataRow
          class="mat-row"
          app-table-empty-content
          [attrColspan]="displayedColumns?.length"
          [message]="'No space template available'"
        ></tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="display-flex grid-gap-8 justify-content-end w-100">
      <button mat-stroked-button color="warn" class="modal-button" (click)="close()">Cancel</button>
    </div>
  </mat-dialog-actions>
</div>
